<template>
  <div>
    <v-row
      :class="{ 'pl-2': true, 'pr-4': true, 'cursor-pointer': true }"
      @click="showTable = !showTable"
    >
      <v-col>
        <v-card-title>
          {{ category }}
          <span class="subtitle-1 lighttext--text my-auto pl-4">
            {{ items.length }} items
          </span>
          <v-spacer />
          <v-btn
            v-if="selected.length > 0"
            color="info"
            @click.stop="$emit('dialog-multiple', selected)"
          >
            Respond to selected
          </v-btn>
        </v-card-title>
      </v-col>
    </v-row>
    <template v-if="showTable">
      <v-divider></v-divider>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="items"
        hide-default-footer
        disable-pagination
        item-key="id"
        show-select
      >
        <template v-slot:item.score="{ item }">
          <v-chip dark :color="$coreScores.getColor(item.score)">
            <template v-if="item.isEndOfSurvey">{{
              item.score | one_decimal
            }}</template>
            <template v-else>{{ item.score | no_decimal }}</template>
          </v-chip>
        </template>
        <template v-slot:item.createdDate="{ item }">
          <span class="text-no-wrap">
            {{ item.createdDate | longDate }}
          </span>
        </template>
        <template v-slot:item.category="{ item }">
          <template v-if="item.coreValueName">
            <span class="font-weight-bold"
              >{{ t("core_values.title_s") }}:
            </span>
            {{ item.coreValueName }}
          </template>
          <template v-else>
            {{ item.category }}
          </template>
        </template>
        <template v-slot:item.text="{ item }">
          <div class="pt-3 font-weight-bold">{{ item.question }}</div>
          <div class="pb-3">{{ item.text }}</div>
        </template>
        <template v-slot:item.acknowledgedDate="{ item }">
          <div class="py-2">
            <v-btn
              :text="!item.acknowledgedDate"
              :color="item.acknowledgedDate ? 'success' : 'info'"
              :class="{
                'light-background': !item.acknowledgedDate
              }"
              @click="$emit('dialog', item)"
            >
              <v-icon class="mr-2" v-if="item.acknowledgedDate">
                check_circle
              </v-icon>
              {{ item.acknowledgedDate ? "Replied" : "Respond" }}
            </v-btn>
            <v-btn
              x-small
              text
              v-if="item.responseMessage"
              @click="$emit('dialog', item)"
              color="info"
              class="pb-2 pt-4"
            >
              <v-icon class="mr-2" x-small>
                message
              </v-icon>
              View Message
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "PulseFeedbackCategory",
  components: {},
  props: { category: { type: String } },
  data: () => ({
    selected: [],
    showTable: false,
    headers: [
      { text: "Score", value: "score", class: "text-no-wrap" },
      { text: "Date", value: "createdDate", class: "text-no-wrap" },
      { text: "Category", value: "category" },
      { text: "Feedback", value: "text" },
      { text: "Status", value: "acknowledgedDate" }
    ]
  }),
  watch: {
    feedback: {
      deep: true,
      handler() {
        this.selected = [];
      }
    }
  },
  computed: {
    items() {
      return this.feedback
        .filter(x => x.category == this.category)
        .map(x => Object.assign(x, { isSelectable: !x.acknowledgedDate }));
    },
    ...mapGetters({
      feedback: "pulse/feedback"
    })
  }
};
</script>

<style lang="scss" scoped>
.v-chip {
  width: 50px;

  ::v-deep .v-chip__content {
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
